import React, { useState } from "react";
import { Button, Modal, ProgressBar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const UploadStockPopup = ({ stockData, setStockData }) => {
  const navigate = useNavigate();
  const [step, setStep] = useState("1");
  const handleStockData = () => setStockData(!stockData);
  const handleRedirect = () => {
    setStep("2");

    // Delay the redirection by 5 to 10 seconds (5000 to 10000 milliseconds)
    setTimeout(() => {
      // Redirect to another URL after the delay
      // navigate("/workbook");
    }, Math.floor(Math.random() * 2000) + 2000); // Random delay between 5 to 10 seconds
  };
  return (
    <>
      <Modal
        className="stockData"
        show={stockData}
        onHide={handleStockData}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body>
          <div className="topHeader d-flex align-items-start justify-content-between gap-10 pb-2">
            <h5 className="m-0 fw-sbold themeClr">Upload Stock Data</h5>
            <Button
              onClick={handleStockData}
              className="border-0 p-0"
              variant="transparent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M14.34 -0.000732422C17.73 -0.000732422 20 2.37927 20 5.91927V14.0903C20 17.6203 17.73 19.9993 14.34 19.9993H5.67C2.28 19.9993 0 17.6203 0 14.0903V5.91927C0 2.37927 2.28 -0.000732422 5.67 -0.000732422H14.34ZM13.01 6.97027C12.67 6.62927 12.12 6.62927 11.77 6.97027L10 8.74927L8.22 6.97027C7.87 6.62927 7.32 6.62927 6.98 6.97027C6.64 7.31027 6.64 7.87027 6.98 8.20927L8.76 9.99027L6.98 11.7603C6.64 12.1103 6.64 12.6603 6.98 12.9993C7.15 13.1693 7.38 13.2603 7.6 13.2603C7.83 13.2603 8.05 13.1693 8.22 12.9993L10 11.2303L11.78 12.9993C11.95 13.1803 12.17 13.2603 12.39 13.2603C12.62 13.2603 12.84 13.1693 13.01 12.9993C13.35 12.6603 13.35 12.1103 13.01 11.7703L11.23 9.99027L13.01 8.20927C13.35 7.87027 13.35 7.31027 13.01 6.97027Z"
                  fill="#EB5757"
                />
              </svg>
            </Button>
          </div>
          <div className="cardBody py-3">
            <p className="m-0">
              Stock data which can be uploaded in any of the below forms.
            </p>
            <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center flex-wrap gap-10">
              <li className=" themeClr">MetaStock (.dat)</li>
              <li className=" themeClr">Format (.csv)</li>
              <li className=" themeClr">API Stock Provider</li>
            </ul>
            {step === "1" ? (
              <>
                <div className="py-2">
                  <div className="uploadFile position-relative p-3 text-center">
                    <input
                      type="file"
                      className="file position-absolute w-100 h-100"
                    />
                    <div className="content">
                      <span className="icn mx-auto my-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="44"
                          height="44"
                          viewBox="0 0 44 44"
                          fill="none"
                        >
                          <rect
                            x="0.5"
                            y="0.5"
                            width="43"
                            height="43"
                            rx="21.5"
                            fill="#F5F5F5"
                          />
                          <rect
                            x="0.5"
                            y="0.5"
                            width="43"
                            height="43"
                            rx="21.5"
                            stroke="black"
                          />
                          <path
                            d="M19.0004 27.75C18.5904 27.75 18.2504 27.41 18.2504 27V22.81L17.5304 23.53C17.2404 23.82 16.7604 23.82 16.4704 23.53C16.1804 23.24 16.1804 22.76 16.4704 22.47L18.4704 20.47C18.6804 20.26 19.0104 20.19 19.2904 20.31C19.5704 20.42 19.7504 20.7 19.7504 21V27C19.7504 27.41 19.4104 27.75 19.0004 27.75Z"
                            fill="url(#paint0_linear_1_303)"
                          />
                          <path
                            d="M21.0004 23.7499C20.8104 23.7499 20.6204 23.6799 20.4704 23.5299L18.4704 21.5299C18.1804 21.2399 18.1804 20.7599 18.4704 20.4699C18.7604 20.1799 19.2404 20.1799 19.5304 20.4699L21.5304 22.4699C21.8204 22.7599 21.8204 23.2399 21.5304 23.5299C21.3804 23.6799 21.1904 23.7499 21.0004 23.7499Z"
                            fill="url(#paint1_linear_1_303)"
                          />
                          <path
                            d="M25 32.75H19C13.57 32.75 11.25 30.43 11.25 25V19C11.25 13.57 13.57 11.25 19 11.25H24C24.41 11.25 24.75 11.59 24.75 12C24.75 12.41 24.41 12.75 24 12.75H19C14.39 12.75 12.75 14.39 12.75 19V25C12.75 29.61 14.39 31.25 19 31.25H25C29.61 31.25 31.25 29.61 31.25 25V20C31.25 19.59 31.59 19.25 32 19.25C32.41 19.25 32.75 19.59 32.75 20V25C32.75 30.43 30.43 32.75 25 32.75Z"
                            fill="url(#paint2_linear_1_303)"
                          />
                          <path
                            d="M32 20.75H28C24.58 20.75 23.25 19.42 23.25 16V12C23.25 11.7 23.43 11.42 23.71 11.31C23.99 11.19 24.31 11.26 24.53 11.47L32.53 19.47C32.74 19.68 32.81 20.01 32.69 20.29C32.57 20.57 32.3 20.75 32 20.75ZM24.75 13.81V16C24.75 18.58 25.42 19.25 28 19.25H30.19L24.75 13.81Z"
                            fill="url(#paint3_linear_1_303)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_1_303"
                              x1="18.0017"
                              y1="20.2515"
                              x2="18.0017"
                              y2="27.75"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3A674A" />
                              <stop offset="1" stopColor="#0C3D1D" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_1_303"
                              x1="20.0004"
                              y1="20.2524"
                              x2="20.0004"
                              y2="23.7499"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3A674A" />
                              <stop offset="1" stopColor="#0C3D1D" />
                            </linearGradient>
                            <linearGradient
                              id="paint2_linear_1_303"
                              x1="22"
                              y1="11.25"
                              x2="22"
                              y2="32.75"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3A674A" />
                              <stop offset="1" stopColor="#0C3D1D" />
                            </linearGradient>
                            <linearGradient
                              id="paint3_linear_1_303"
                              x1="27.9993"
                              y1="11.2515"
                              x2="27.9993"
                              y2="20.75"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3A674A" />
                              <stop offset="1" stopColor="#0C3D1D" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </span>
                      <h6 className="m-0">
                        {" "}
                        <span className="themeClr fw-sbold">
                          Click to Upload
                        </span>{" "}
                        or drag and drop
                      </h6>
                      <p className="m-0"> (Max. File size: 25 MB)</p>
                    </div>
                  </div>
                </div>
                <div className="btnWrpper mt-4">
                  <Button
                    onClick={handleRedirect}
                    className="d-flex align-items-center justify-content-center commonBtn w-100 borderedBtn"
                  >
                    Import
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div className="py-2">
                  <div className="progressCard py-2 px-3">
                    <div className="d-flex align-items-start justify-content-between top mb-2   ">
                      <div className="left d-flex align-items-start">
                        <span className="icn me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M12.5003 18.9584H7.50033C2.97533 18.9584 1.04199 17.0251 1.04199 12.5001V7.50008C1.04199 2.97508 2.97533 1.04175 7.50033 1.04175H11.667C12.0087 1.04175 12.292 1.32508 12.292 1.66675C12.292 2.00841 12.0087 2.29175 11.667 2.29175H7.50033C3.65866 2.29175 2.29199 3.65841 2.29199 7.50008V12.5001C2.29199 16.3417 3.65866 17.7084 7.50033 17.7084H12.5003C16.342 17.7084 17.7087 16.3417 17.7087 12.5001V8.33342C17.7087 7.99175 17.992 7.70842 18.3337 7.70842C18.6753 7.70842 18.9587 7.99175 18.9587 8.33342V12.5001C18.9587 17.0251 17.0253 18.9584 12.5003 18.9584Z"
                              fill="#202020"
                            />
                            <path
                              d="M18.3337 8.9584H15.0003C12.1503 8.9584 11.042 7.85007 11.042 5.00007V1.66674C11.042 1.41674 11.192 1.18341 11.4253 1.09174C11.6587 0.991739 11.9253 1.05007 12.1087 1.22507L18.7753 7.89174C18.9503 8.06674 19.0087 8.34174 18.9087 8.57507C18.8087 8.8084 18.5837 8.9584 18.3337 8.9584ZM12.292 3.17507V5.00007C12.292 7.15007 12.8503 7.70841 15.0003 7.70841H16.8253L12.292 3.17507Z"
                              fill="#202020"
                            />
                            <path
                              d="M10.833 11.4583H5.83301C5.49134 11.4583 5.20801 11.1749 5.20801 10.8333C5.20801 10.4916 5.49134 10.2083 5.83301 10.2083H10.833C11.1747 10.2083 11.458 10.4916 11.458 10.8333C11.458 11.1749 11.1747 11.4583 10.833 11.4583Z"
                              fill="#202020"
                            />
                            <path
                              d="M9.16634 14.7917H5.83301C5.49134 14.7917 5.20801 14.5084 5.20801 14.1667C5.20801 13.8251 5.49134 13.5417 5.83301 13.5417H9.16634C9.50801 13.5417 9.79134 13.8251 9.79134 14.1667C9.79134 14.5084 9.50801 14.7917 9.16634 14.7917Z"
                              fill="#202020"
                            />
                          </svg>
                        </span>
                        <div className="content">
                          <p className="m-0">MetaStock_tcs.dat</p>
                          <span className="text-muted">200 KB</span>
                        </div>
                      </div>
                      <Button className="border-0 p-0" variant="transparent">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M17.5001 5.60839C17.4834 5.60839 17.4584 5.60839 17.4334 5.60839C13.0251 5.16673 8.62505 5.00006 4.26672 5.44173L2.56672 5.60839C2.21672 5.64173 1.90839 5.39173 1.87505 5.04173C1.84172 4.69173 2.09172 4.39173 2.43339 4.35839L4.13339 4.19173C8.56672 3.74173 13.0584 3.91673 17.5584 4.35839C17.9001 4.39173 18.1501 4.70006 18.1167 5.04173C18.0917 5.36673 17.8167 5.60839 17.5001 5.60839Z"
                            fill="#EB5757"
                          />
                          <path
                            d="M7.08363 4.76675C7.05029 4.76675 7.01696 4.76675 6.97529 4.75842C6.64196 4.70008 6.40863 4.37508 6.46696 4.04175L6.65029 2.95008C6.78363 2.15008 6.96696 1.04175 8.90863 1.04175H11.092C13.042 1.04175 13.2253 2.19175 13.3503 2.95841L13.5336 4.04175C13.592 4.38342 13.3586 4.70842 13.0253 4.75842C12.6836 4.81675 12.3586 4.58342 12.3086 4.25008L12.1253 3.16675C12.0086 2.44175 11.9836 2.30008 11.1003 2.30008H8.91696C8.03363 2.30008 8.01696 2.41675 7.89196 3.15841L7.70029 4.24175C7.65029 4.55008 7.38363 4.76675 7.08363 4.76675Z"
                            fill="#EB5757"
                          />
                          <path
                            d="M12.675 18.9584H7.325C4.41666 18.9584 4.3 17.3501 4.20833 16.0501L3.66666 7.6584C3.64166 7.31673 3.90833 7.01673 4.25 6.99173C4.6 6.97506 4.89166 7.2334 4.91666 7.57506L5.45833 15.9667C5.55 17.2334 5.58333 17.7084 7.325 17.7084H12.675C14.425 17.7084 14.4583 17.2334 14.5417 15.9667L15.0833 7.57506C15.1083 7.2334 15.4083 6.97506 15.75 6.99173C16.0917 7.01673 16.3583 7.3084 16.3333 7.6584L15.7917 16.0501C15.7 17.3501 15.5833 18.9584 12.675 18.9584Z"
                            fill="#EB5757"
                          />
                          <path
                            d="M11.3834 14.375H8.6084C8.26673 14.375 7.9834 14.0917 7.9834 13.75C7.9834 13.4083 8.26673 13.125 8.6084 13.125H11.3834C11.7251 13.125 12.0084 13.4083 12.0084 13.75C12.0084 14.0917 11.7251 14.375 11.3834 14.375Z"
                            fill="#EB5757"
                          />
                          <path
                            d="M12.0837 11.0417H7.91699C7.57533 11.0417 7.29199 10.7584 7.29199 10.4167C7.29199 10.0751 7.57533 9.79175 7.91699 9.79175H12.0837C12.4253 9.79175 12.7087 10.0751 12.7087 10.4167C12.7087 10.7584 12.4253 11.0417 12.0837 11.0417Z"
                            fill="#EB5757"
                          />
                        </svg>
                      </Button>
                    </div>
                    <ProgressBar now={60} />
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UploadStockPopup;
